var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDragPanIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 21.6538L8.09619 17.75L9.16544 16.6807L11.2499 18.7655V12.75H5.24994L7.33444 14.8192L6.24994 15.9038L2.34619 12L6.23444 8.1115L7.30369 9.18075L5.23444 11.25H11.2499V5.2345L9.16544 7.31925L8.09619 6.25L11.9999 2.34625L15.9037 6.25L14.8344 7.31925L12.7499 5.2345V11.25H18.7499L16.6654 9.18075L17.7499 8.09625L21.6537 12L17.7499 15.9038L16.6807 14.8345L18.7654 12.75H12.7499V18.75L14.8192 16.6655L15.9037 17.75L11.9999 21.6538Z",
    fill: "#25272C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragPanIcon);
export default __webpack_public_path__ + "static/media/drag_pan-icon.8d547fd53df1111b41eeafc55dc98668.svg";
export { ForwardRef as ReactComponent };